const CareerForm = () => {
  return (
    <>
      <div className="d-flex flex-column align-items-center">
        <h3 className="text-center mb-4">Submit Your Profile</h3>
        <form
          action="./mail/careers-mail-validation.php"
          method="POST"
          id="contactForm"
          encType="multipart/form-data"
          className="w-75 mx-auto"
        >
          <div className="mb-3">
            <label className="form-label text-start w-100">Your Name</label>
            <input type="text" name="name" className="form-control" required />
          </div>

          <div className="mb-3">
            <label className="form-label text-start w-100">Your Email</label>
            <input
              type="email"
              name="email"
              className="form-control"
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label text-start w-100">Phone Number</label>
            <input type="tel" name="phone" className="form-control" required />
          </div>

          <div className="mb-3">
            <label className="form-label text-start w-100">Attach Resume</label>
            <input
              type="file"
              name="file"
              id="inputGroupFile04"
              className="form-control"
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label text-start w-100">Message</label>
            <textarea
              id="message"
              name="message"
              className="form-control"
              rows="4"
            ></textarea>
          </div>

          <div className="text-center ">
            <button type="submit" className="btn btn-dark w-100">
              Submit
            </button>
          </div>
          <h3 className="mt-4 text-center text-muted">Or</h3>
          <p className="mt-2 text-center text-muted">
            Send your resume to{" "}
            <a href="mailto:Info@Tbiti.Com">Info@Tbiti.Com</a>
          </p>
        </form>
      </div>
    </>
  );
};

export default CareerForm;
